import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDataGridTextFilter } from '../../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import { dataGridTextSorter } from '../../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import DataGrid from '../../../../../common/DataGrid/DataGrid.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import { YELLOW_BOOKS_SECTION_TYPES } from '../../../../../../utils/constants/enums.js';

const SectionsTable = ({ sections, onDelete, onDetailClick }) => {
  const { t } = useTranslation();
  const titleSkTextFilterProps = useDataGridTextFilter('title_sk');
  const locationTextFilterProps = useDataGridTextFilter('location');
  const lastUpdated = useDataGridTextFilter('updated_at');

  const getItemTypeLabel = (itemTypeId) => {
    const itemType = Object.values(YELLOW_BOOKS_SECTION_TYPES).find(
      (type) => type.id === itemTypeId,
    );
    return itemType ? itemType.label : itemTypeId;
  };

  const columns = useMemo(
    () => [
      {
        title: t('Názov'),
        dataIndex: 'title_sk',
        ellipsis: true,
        sorter: dataGridTextSorter('title_sk'),
        defaultSortOrder: 'ascend',
        ...titleSkTextFilterProps,
      },
      {
        title: t('Typ sekcie'),
        dataIndex: 'item_type',
        ellipsis: true,
        sorter: dataGridTextSorter('item_type'),
        render: (item_type) => getItemTypeLabel(item_type),
        width: 150,
      },
      {
        title: t('Umiestnenie'),
        dataIndex: 'location',
        ellipsis: true,
        sorter: dataGridTextSorter('location'),
        ...locationTextFilterProps,
      },
      {
        title: t('Posledná úprava'),
        dataIndex: 'updated_at',
        ellipsis: true,
        width: 200,
        sorter: dataGridTextSorter('updated_at'),
        render: (value) => {
          return value ? new Date(value).toLocaleString() : '';
        },
        ...lastUpdated,
      },
    ],
    [t, titleSkTextFilterProps, locationTextFilterProps, lastUpdated],
  );

  if (!sections) {
    return <Spinner />;
  }

  return (
    <DataGrid
      rowKey={(section) => section.id}
      columns={columns}
      dataSource={sections || []}
      permissionsBasic={'yellow-books'}
      onEditClick={onDetailClick}
      onRowClick={onDetailClick}
      onDelete={onDelete}
    />
  );
};

SectionsTable.propTypes = {
  sections: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default SectionsTable;
